const FOOTER_LINKS = {
  '漫画分类': ['韩漫下拉式', '日漫下拉式', '国漫专区', '恋爱甜漫', '热血战斗', '悬疑推理'],
  '关于平台': ['关于我们', '常见问答', '联系我们', '最新动态', '漫画排行'],
  '热门话题': ['韩漫推荐', '日漫新番', '漫画安利', '完结神作', '追更日记'],
  '合作伙伴': ['友情链接一', '友情链接二', '友情链接三', '友情链接四', '友情链接五'],
};

export default function Footer() {
  const handleNavClick = (label: string) => {
    const idMap: Record<string, string> = {
      '关于我们': 'about',
      '常见问答': 'faq',
      '联系我们': 'contact',
      '最新动态': 'updates',
      '漫画排行': 'ranking',
    };
    const targetId = idMap[label];
    if (targetId) {
      const el = document.getElementById(targetId);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16 max-w-[1280px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          {Object.entries(FOOTER_LINKS).map(([category, links]) => (
            <div key={category}>
              <div className="font-bold text-background-50 text-sm mb-4">{category}</div>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link}>
                    <a
                      href={`#${link}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleNavClick(link);
                      }}
                      className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-700/40 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <span className="font-fun text-xl text-primary-400">43423</span>
              <span className="text-sm font-bold text-background-200">漫画网</span>
            </div>

            <p className="text-xs text-background-500 text-center">
              43423漫画网 —— 下拉式漫画免费在线阅读平台 · 韩漫下拉式 · 日漫下拉式 · 漫画大全
            </p>

            <div className="text-xs text-background-500">
              © 2026 43423漫画网
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}